import { Dropdown, Menu, Pagination, PaginationProps, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { RootState } from "../../redux/rootReducer";
import { Actions, PageSize } from "../../shared/constant";
import { isClapAdminORClapManager } from "../../utils/clapUtils";
import icons from "../../shared/icons";
import CatalogHeader from "../../components/_shared/CatalogHeader";
import SearchComponent from "../../components/_shared/SearchComponent";
import tableUtils from "../../utils/tableUtils";
import { DistributorColumn } from "../../shared/table/columns";
import DistributorModalForm from "../../components/catalog/DistributorModalForm";
import {
  getDistributors,
  resetDistributorList,
} from "../../redux/actions/distributorActions";

function Distributor() {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState(null);
  const [effect, setEffect] = useState(false);
  const { distributors, distributorCount, distributorListPending } =
    useSelector((state: RootState) => state.distributor);
  const { userDetails } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    dispatch(resetDistributorList());
  }, []);

  useEffect(() => {
    dispatch(getDistributors({ page, searchText, pageSize: PageSize.DEFAULT }));
  }, [page, effect]);

  const handleSearch = (value: string) => {
    setSearchText(value);
    setPage(1);
    setEffect(!effect);
  };

  const handlePageChange: PaginationProps["onChange"] = (p) => {
    setPage(p);
  };

  const onCreate = () => {
    setMode(Actions.CREATE);
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
    setMode("");
    setEditData(null);
  };

  const callEffect = () => {
    setEffect(!effect);
  };

  const onEdit = (record: any) => {
    setMode(Actions.EDIT);
    setVisible(true);
    setEditData(record);
  };

  const actions = {
    title: "",
    key: "action",
    align: "right",
    render: (_: any, record: any) =>
      isClapAdminORClapManager(userDetails) && (
        <div className="text-secondary">
          <Dropdown
            overlay={
              <Menu
                className="min-w-[100px] rounded-[3px]"
                items={[
                  {
                    label: (
                      <div onClick={() => onEdit(record)} aria-hidden="true">
                        Edit
                      </div>
                    ),
                    key: "EDIT",
                  },
                ]}
              />
            }
            trigger={["click"]}
          >
            <button type="button">{icons.DotsVerticle()}</button>
          </Dropdown>
        </div>
      ),
  };

  return (
    <div>
      <div>
        <CatalogHeader title="Distributors" handleClick={onCreate} />
        <DistributorModalForm
          visible={visible}
          onCancel={hideModal}
          callEffect={callEffect}
          mode={mode}
          editData={editData}
        />
      </div>
      <div className="mt-5 mb-4">
        <SearchComponent handleSearch={handleSearch} />
      </div>
      <div>
        <Table
          rowKey={(record: any) => {
            return record.id;
          }}
          columns={tableUtils.buildColumns(
            distributors,
            DistributorColumn,
            actions,
          )}
          dataSource={distributors}
          pagination={false}
          size="middle"
          className="ant_table"
          loading={{
            spinning: distributorListPending as boolean,
            indicator: <LoadingOutlined style={{ fontSize: 34 }} />,
          }}
        />
      </div>
      <div className="text-right mt-4">
        <Pagination
          current={page}
          pageSize={PageSize.DEFAULT}
          onChange={handlePageChange}
          total={distributorCount}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
}

export default Distributor;
